import axios, {
  AxiosError,
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
} from "axios";

import config from "../config";

const MESSAGES = {
  OFFLINE: "You are offline, Please connect internet",
  NOT_REACHABLE: "Internal server error",
  UNKNOWN: "Something went wrong, Please contact to administrator",
  REQUEST_CANCELLED: "request cancelled by user",
  SESSION_EXPIRED: "Session expired",
};

class NetworkService {
  private client: AxiosInstance;
  constructor() {
    this.client = axios.create({
      baseURL: config.VECTOR_AI_URL,
    });
  }

  async get<T = any>(url: string, options?: AxiosRequestConfig) {
    try {
      const response = await this.client.get<T>(url, options);
      return this.handleResponse(response);
    } catch (error) {
      this.handleError(error);
    }
  }

  async post<T = any>(url: string, data?: any, options?: AxiosRequestConfig) {
    try {
      const response = await this.client.post<T>(url, data, options);
      return this.handleResponse(response);
    } catch (error) {
      this.handleError(error);
    }
  }

  private handleError<T>(error: AxiosError<T> | NetworkError) {
    if (error instanceof NetworkError) {
      throw error;
    }

    if (error.message === "Network Error") {
      throw new NetworkError(MESSAGES.NOT_REACHABLE);
    }

    if (error.response) {
      if (error.response.status === 401) {
        throw new NetworkError(MESSAGES.SESSION_EXPIRED);
      }

      throw new NetworkError(MESSAGES.UNKNOWN);
    }
    throw new NetworkError(MESSAGES.UNKNOWN);
  }

  private handleResponse<T>(response: AxiosResponse<T>) {
    if (response.status !== 200 && response.status !== 201) {
      throw new NetworkError(MESSAGES.UNKNOWN);
    }

    return response.data;
  }

  public buildUrlFromQueryParams(url: string, params?: { [key: string]: any }) {
    if (!params) {
      return url;
    }
    const temp = `${url}?${Object.keys(params)
      .map((key) => `${key}=${params[key]}`)
      .join("&")}`;
    return temp;
  }
}

class NetworkError extends Error {}

export class ApiError extends Error {}

export default new NetworkService();
